/* eslint-disable max-len */
import React from 'react';
function TagsOutlined() {
    return (React.createElement("g", null,
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.5 5C16.17 5 16.77 5.33 17.13 5.84L21.5 12L17.13 18.16C16.77 18.67 16.17 19 15.5 19L4.5 18.99C3.4 18.99 2.5 18.1 2.5 17V7C2.5 5.9 3.4 5.01 4.5 5.01L15.5 5ZM4.5 17H15.5L19.05 12L15.5 7H4.5V17Z" })));
}
export default TagsOutlined;
